module.exports = __webpack_public_path__ + "img/68_7.d7b6fda1.png";